import dayjs from 'dayjs';

import { Maybe } from 'types/UtilityTypes';

// Default pickup/delivery when building quick-quote form values.
export function resolveQuickQuoteDates(
  suggestedPickup: Maybe<Date>,
  suggestedDelivery: Maybe<Date>,
  now: Date = new Date()
): { pickupDate: Date; deliveryDate: Date } {
  const today = dayjs(now).startOf('day');

  const pickupDate = suggestedPickup ?? today.add(1, 'day').toDate();

  const defaultDeliveryDate = suggestedPickup
    ? dayjs(suggestedPickup).add(1, 'day').toDate()
    : today.add(2, 'day').toDate();

  const deliveryDate = suggestedDelivery ?? defaultDeliveryDate;

  return { pickupDate, deliveryDate };
}
